// extracted by mini-css-extract-plugin
module.exports = {"picture-component":"Picture_picture-component__nrXT1","picture-lazy":"Picture_picture-lazy__M8K_Z"};